import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/PageHeader";
import { FirmChip } from "@/components/Profiles/ListFilters";
import { articleKeys, articlesService } from "@/api/profiles";
import { ArticleForm } from "./ArticleForm";
import styles from "../ProfilesForm.module.css";

export function ArticleDetail() {
  const params = useParams<{ id: string }>();
  const id = params.id ?? "";

  const articleQuery = useQuery({
    queryKey: articleKeys.detail(id),
    queryFn: () => articlesService.get(id),
    enabled: Boolean(id),
  });

  if (articleQuery.isPending) {
    return (
      <div className={styles.wrapper}>
        <PageHeader title="Article" />
        <p role="status" className={styles.muted}>
          Loading…
        </p>
      </div>
    );
  }

  if (articleQuery.isError || !articleQuery.data) {
    return (
      <div className={styles.wrapper}>
        <PageHeader title="Article" />
        <p role="alert" className={styles.errorBanner}>
          {articleQuery.error instanceof Error
            ? articleQuery.error.message
            : "Failed to load article"}
        </p>
      </div>
    );
  }

  const article = articleQuery.data;

  return (
    <div className={styles.wrapper}>
      <PageHeader
        title={`Edit article: ${article.title}`}
        meta={<FirmChip companyId={article.companyId} />}
      />
      <ArticleForm existing={article} companyId={article.companyId} />
    </div>
  );
}

export default ArticleDetail;
